import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Legal() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions légales</h1>
        <div className="prose prose-blue max-w-none">
          <p>Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          
          <p>
            Conformément à l'article 6 de la Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), 
            les informations suivantes sont portées à la connaissance des utilisateurs du site Sibystock (https://sibystock.com) :
          </p>

          <h2>1. Éditeur du site</h2>
          <p>
            Le site Sibystock est édité par :<br />
            Sibyagence<br /><br />
            Statut juridique : Auto-entrepreneur<br />
            SIRET : 84229495100020<br />
            Contact : contact@sibyagence.com<br />
            Directeur de la publication : Banta SIBY
          </p>

          <h2>2. Hébergement</h2>
          <p>
            Le site Sibystock est hébergé par :<br />
            Vercel, Inc.<br /><br />
            Adresse : 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis<br />
            Téléphone : +1 (951) 383-6898<br />
            Site web : https://vercel.com
          </p>

          <h2>3. Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus (textes, images, logos, vidéos, éléments graphiques, etc.) présents sur le site Sibystock 
            sont protégés par les lois en vigueur sur la propriété intellectuelle.
          </p>
          <p>
            Toute reproduction, représentation, modification ou exploitation, totale ou partielle, des contenus du site est 
            strictement interdite sans l'autorisation préalable et écrite de Sibyagence.
          </p>

          <h2>4. Limitation de responsabilité</h2>
          <p>
            Sibyagence s'efforce de fournir des informations exactes et à jour sur le site. Toutefois, l'éditeur ne saurait être tenu responsable :
          </p>
          <ul>
            <li>Des éventuelles erreurs ou omissions</li>
            <li>De l'interprétation ou de l'utilisation des informations disponibles sur le site</li>
            <li>Des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site</li>
          </ul>

          <h2>5. Protection des données personnelles</h2>
          <p>
            Le traitement des données personnelles des utilisateurs est conforme au Règlement Général sur la Protection des 
            Données (RGPD) et à la législation française en vigueur.
          </p>
          <p>
            Pour plus d'informations, consultez notre Politique de confidentialité.
          </p>

          <h2>6. Cookies</h2>
          <p>
            Le site Sibystock utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. Lors de votre 
            première visite, une bannière vous permet de gérer vos préférences en matière de cookies.
          </p>
          <p>
            Pour en savoir plus, consultez notre Politique de gestion des cookies.
          </p>

          <h2>7. Droit applicable et juridiction compétente</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français. En cas de litige, la compétence est attribuée 
            aux tribunaux du ressort de Vénissieux, sauf disposition légale contraire.
          </p>

          <h2>8. Contact</h2>
          <p>
            Pour toute question ou réclamation, vous pouvez nous contacter :<br />
            Par email : contact@sibyagence.com
          </p>
        </div>
      </main>
    </div>
  );
}